export default {"src":"/_next/static/media/wrench_64.6753964d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};